import { render, staticRenderFns } from "./RsaSchedaAreaMobilitaModalEditComponent.vue?vue&type=template&id=32e1abf6"
import script from "./RsaSchedaAreaMobilitaModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAreaMobilitaModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports